import { Injectable } from '@angular/core';
import {URL_API} from '../../tools/URL';
import {RestService} from '../rest.service';

@Injectable({
  providedIn: 'root'
})
export class ProcessoJudicialService {

  constructor(private rest: RestService) { }

  public buscarProcesso(numeroProcesso: string, tipoJustica: string) {

    const numeroProcessoSomenteNumero = numeroProcesso.replace('-', '').split('.').join('');
    return this.rest.get(`${URL_API.PATH_INFORMACAO}/processo/buscar`, {
      numeroProcesso: numeroProcessoSomenteNumero,
      tipoJustica
    });
  }

}
